<i18n>
{
  "fr": {
    "prismic-content-no-result-error": "Aucun contenu n'a été trouvé pour ces critères."
  },
  "en": {
    "prismic-content-no-result-error": "No content has been found for these criteria."
  }
}
</i18n>

<template>
  <div>
    <s-loader :active="!content && loading" />
    <slot :response="response" :content="content" v-if="content"></slot>
    <slot name="error" :error="error" v-if="error">{{ error }}</slot>
  </div>
</template>

<script>
import Prismic from 'prismic-javascript'
import CmsService from '@/services/cms'

export default {
  data() {
    return {
      loading: false,
      content: null,
      response: null,
      error: null
    }
  },
  props: {
    uid: String,
    doctype: String,
    rawPredicates: Array
  },
  computed: {
    predicates() {
      // L'idée est qu'on s'occupe de construire la liste des predicates selon les props reçues.
      // On supporte aussi rawPredicates pour overrider la logique et permettre à l'appelant de créer sa propre requête.

      if (this.rawPredicates) return this.rawPredicates

      const predicates = []
      if (this.uid) {
        if (!this.doctype) {
          throw new Error('Property "doctype" is needed with uid queries.')
        }
        predicates.push(Prismic.Predicates.at(`my.${this.doctype}.uid`, this.uid))
      }
      if (this.doctype) {
        predicates.push(Prismic.Predicates.at('document.type', this.doctype))
      }

      return predicates
    },
    queryArgs() {
      // Cette propriété retourne toutes les variables qui peuvent impacter
      // les résultats de la requête prismic, c-a-d les critères et la langue actuelle.
      // Le watch va détecter tout changement et ré-exécuter la requête
      return [this.predicates, CmsService.currentLocale()]
    }
  },
  methods: {
    async fetchContent() {
      this.loading = true
      try {
        const result = await CmsService.getFirstPageByPredicates(this.predicates)
        if (!result) {
          this.error = this.$t('prismic-content-no-result-error')
        } else {
          this.error = null
        }

        this.content = result ? result.data : null
        this.response = result ? result : null

        this.$emit('loaded')
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    async queryArgs(args) {
      await this.fetchContent()
    }
  },
  async mounted() {
    await this.fetchContent()
  }
}
</script>
